/* eslint-disable no-param-reassign */
import {
  createSlice
} from '@reduxjs/toolkit';

const CreateOOBInvitation = createSlice({
  name: 'createOOBInvitation',
  initialState: {
    loading: false,
    data: {},
    error: null,
  },
  reducers: {
    fetchCreateOOBInvitationStarted(state) {
      state.loading = true;
    },
    fetchCreateOOBInvitationSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.error = false;
    },
    fetchCreateOOBInvitationError(state, action) {
      state.loading = false;
      state.error = true;
      state.data = false;
    },
    setDefaultPostError(state) {
      state.error = false;
      state.data = false;
    },
  },
});

export const {
  fetchCreateOOBInvitationStarted,
  fetchCreateOOBInvitationSuccess,
  fetchCreateOOBInvitationError,
  setDefaultPostError,
} = CreateOOBInvitation.actions;

export default CreateOOBInvitation.reducer;